import React from 'react'
import { withRouter, Link } from 'react-router-dom'
import { slide as MenuList } from 'react-burger-menu'
import { connect } from 'react-redux'
import WelcomeHeader from 'components/layout/WelcomeHeader'
import logoNew from '@assets/images/v2-dashboard/logo-new.svg'
import {
  isAppAdmin,
  isAppOwner,
  checkIfPlanExpired,
  checkIfFeatureRestricted,
} from '../../../../helpers'
import './sidebar.css'
import AppNavMenu from './components/appNavMenu'
import AppNavMenuFooter from './components/appNavMenuFooter'
import style from '../style.module.scss'

const mapStateToProps = ({ apps, settings }) => ({ apps, settings })

@withRouter
@connect(mapStateToProps)
class Menu extends React.Component {
  handleFetchUsers = () => {
    const { dispatch, apps } = this.props
    if (apps.active.id !== undefined && apps.active.scheduledToDeleteAt === undefined) {
      dispatch({
        type: 'apps/ENTER_USER_TEXT',
        payload: {
          searchText: '',
          clearText: true,
        },
      })
      dispatch({
        type: 'apps/USERS_LIST',
        payload: { currentPage: 1 },
      })
    }
  }

  handleFetchGroups = () => {
    const { dispatch, apps } = this.props
    if (apps.active.id !== undefined && apps.active.scheduledToDeleteAt === undefined) {
      dispatch({
        type: 'apps/ENTER_GROUP_TEXT',
        payload: {
          searchText: '',
          clearText: true,
        },
      })
      dispatch({
        type: 'apps/GROUPS_LIST',
        payload: { currentPage: 1 },
      })
    }
  }

  handleFetchRoles = () => {
    const { dispatch, apps } = this.props
    if (apps.active.id !== undefined && apps.active.scheduledToDeleteAt === undefined) {
      dispatch({
        type: 'apps/ENTER_ROLE_TEXT',
        payload: {
          searchText: '',
          clearText: true,
        },
      })
      dispatch({
        type: 'apps/ROLES_LIST',
        payload: { currentPage: 1 },
      })
      dispatch({
        type: 'apps/ROLES_PERMISSIONS_LIST',
        payload: {},
      })
    }
  }

  handleFetchApiKeys = () => {
    const { dispatch, apps } = this.props
    if (apps.active.id !== undefined && apps.active.scheduledToDeleteAt === undefined) {
      dispatch({
        type: 'apps/API_KEYS_LIST',
        payload: { currentPage: 1 },
      })
    }
  }

  handleFetchExtensions = () => {
    const { dispatch, apps } = this.props
    if (apps.active.id !== undefined && apps.active.scheduledToDeleteAt === undefined) {
      dispatch({
        type: 'apps/EXTENSIONS_LIST',
      })
    }
  }

  handleFetchNotificationLogs = () => {
    const { dispatch, apps } = this.props
    if (apps.active.id !== undefined && apps.active.scheduledToDeleteAt === undefined) {
      // Clear stored filters in Redux before fetching, so navigation always starts fresh
      dispatch({
        type: 'apps/SET_STATE',
        payload: {
          notificationLogsFilters: {},
        },
      })
      dispatch({
        type: 'apps/NOTIFICATION_LOGS',
        payload: { paginationType: '', filters: {}, pageNo: 1 },
      })
    }
  }

  handleFetchBots = () => {
    const { dispatch, apps } = this.props
    if (apps.active.id !== undefined && apps.active.scheduledToDeleteAt === undefined) {
      dispatch({
        type: 'apps/BOTS_LIST',
        payload: { currentPage: 1 },
      })
    }
  }

  handleFetchModerationComponents = () => {
    const { dispatch, apps } = this.props
    if (apps.active.id !== undefined && apps.active.scheduledToDeleteAt === undefined) {
      dispatch({
        type: 'apps/MODERATION_LIST_DROPPED_MESSAGES',
        payload: { currentPage: 1 },
      })
      dispatch({
        type: 'apps/MODERATION_LIST_RULES',
        payload: { currentPage: 1 },
      })
      dispatch({
        type: 'apps/MODERATION_LIST_KEYWORDS',
        payload: { currentPage: 1 },
      })
      dispatch({
        type: 'apps/MODERATION_LIST_CONFIGURATION',
        payload: { currentPage: 1 },
      })
    }
  }

  handleFetchWebhooks = () => {
    const { dispatch, apps } = this.props
    if (apps.active.id !== undefined && apps.active.scheduledToDeleteAt === undefined) {
      dispatch({
        type: 'apps/WEBHOOKS_LIST',
        payload: { currentPage: 1 },
      })
      dispatch({
        type: 'apps/TRIGGERS_LIST',
        payload: { currentPage: 1 },
      })
    }
  }

  handleFetchWebhooksNew = () => {
    const { dispatch, apps } = this.props

    if (apps.active.id !== undefined && apps.active.scheduledToDeleteAt === undefined) {
      dispatch({
        type: 'apps/WEBHOOKS_LIST_NEW',
        payload: { currentPage: 1 },
      })
      dispatch({
        type: 'apps/TRIGGERS_LIST_NEW',
        payload: { currentPage: 1 },
      })
    }
  }

  handleFetchAllWebhooks = () => {
    this.handleFetchWebhooksNew()
    this.handleFetchWebhooks()
  }

  getWebhookRoutes = () => {
    const { apps } = this.props
    const appID = apps.active.id
    return !checkIfFeatureRestricted(apps.active, 'legacy_webhooks') &&
      checkIfFeatureRestricted(apps.active, 'advanced_webhooks_accessible') &&
      checkIfFeatureRestricted(apps.active, 'basic_webhooks_accessible') &&
      checkIfFeatureRestricted(apps.active, 'advanced_plus_webhooks_accessible')
      ? `/app/${appID}/webhooks-legacy`
      : `/app/${appID}/webhooks`
  }

  handleFetchAnalytics = () => {
    const { dispatch, apps } = this.props
    if ((isAppAdmin(apps.active) || isAppOwner(apps.active)) && apps.active.id !== undefined) {
      dispatch({
        type: 'apps/GET_METRICS',
        payload: {},
      })
      dispatch({
        type: 'apps/GET_USAGE_AND_OVERAGES',
        payload: {},
      })
    }
  }

  handleFetchAppData = page => {
    const { dispatch, apps } = this.props
    dispatch({
      type: 'apps/UPDATE_ACTIVE_APP',
      payload: {
        id: 0,
        fetchAllData: false,
      },
    })
    if (apps.active.id !== undefined && apps.active.scheduledToDeleteAt === undefined) {
      if (page === 'billing') {
        dispatch({
          type: 'apps/EXTENSIONS_LIST',
        })

        dispatch({
          type: 'apps/GET_USAGE_AND_OVERAGES',
          payload: {},
        })
      }
      if (page === 'quickstart') {
        dispatch({
          type: 'apps/API_KEYS_LIST',
          payload: { currentPage: 1 },
        })
      }
      if (page === 'messages') {
        dispatch({
          type: 'apps/GET_MESSAGE_LOGS',
          payload: { currentPage: 1, type: 'current' },
        })
      }
      if (page === 'widgets') {
        dispatch({
          type: 'apps/EXTENSIONS_LIST',
        })
        dispatch({
          type: 'apps/CHAT_WIDGETS_LIST',
        })
      }
      if (page === 'messages') {
        dispatch({
          type: 'apps/EXTENSIONS_LIST',
        })
        dispatch({
          type: 'apps/GET_MOD_MESSAGE_LOGS',
          payload: { currentPage: 1 },
        })
        dispatch({
          type: 'apps/GET_MESSAGE_LOGS',
          payload: { currentPage: 1, type: 'current' },
        })
      }
      if (page === 'calls') {
        dispatch({
          type: 'apps/GET_CALL_LOGS',
          payload: {},
        })
      }
      if (page === 'members') {
        dispatch({
          type: 'apps/TEAM_COLLABORATOR_LIST',
          payload: { currentPage: 1 },
        })
      }
    }
  }

  handleFetchAIAgentUserList = () => {
    console.log('Fetching AI Agent User List')
    const { dispatch } = this.props
    dispatch({
      type: 'apps/AI_AGENT_USER_LIST',
      payload: {},
    })
  }

  render() {
    const { appID, activeApp, location, settings, apps, displayBanner } = this.props

    const appExpired = checkIfPlanExpired(apps.active.plan)
    const appDeleted = apps?.active?.state || false

    return (
      <>
        <div className={style.menu} style={displayBanner ? { height: 'calc(100vh - 32px)' } : {}}>
          {settings.isMobileView ? (
            <MenuList customCrossIcon={<div className={style.closeSidebar} />}>
              <div>
                <div className={style.HeaderBrandingLogoWrapperFlex}>
                  {!settings.isMobileView ? (
                    <div className={style.HeaderBrandingLogoWrapper}>
                      <Link to="/apps" style={{ margin: '0px', lineHeight: '1.4' }}>
                        <img src={logoNew} alt="cometchat" />
                      </Link>
                    </div>
                  ) : (
                    <div>{null}</div>
                  )}
                </div>

                <div className={style.appNavAppItemsContainer}>
                  {' '}
                  <AppNavMenu
                    appID={appID}
                    activeApp={activeApp}
                    handleFetchAnalytics={() => this.handleFetchAnalytics()}
                    handleFetchUsers={() => this.handleFetchUsers()}
                    handleFetchGroups={() => this.handleFetchGroups()}
                    handleFetchRoles={() => this.handleFetchRoles()}
                    handleFetchChats={() => {
                      this.handleFetchAppData('moderation')
                      this.handleFetchAppData('messages')
                    }}
                    handleFetchCalls={() => this.handleFetchAppData('calls')}
                    handleFetchWidgets={() => this.handleFetchAppData('widgets')}
                    handleFetchModeration={() => {
                      this.handleFetchModerationComponents()
                    }}
                    handleFetchAIAgentUserList={() => {
                      this.handleFetchAIAgentUserList()
                    }}
                    handleFetchSettings={() => {
                      this.handleFetchAppData('settings')
                    }}
                    handleFetchCredentials={() => {
                      this.handleFetchApiKeys()
                    }}
                    handleFetchPlans={() => {
                      this.handleFetchAppData('billing')
                    }}
                    handleFetchMembers={() => {
                      this.handleFetchAppData('members')
                    }}
                    handleFetchBots={() => {
                      this.handleFetchBots()
                    }}
                    handleFetchWebhooks={() => {
                      this.handleFetchAllWebhooks()
                    }}
                    handleFetchExtensions={() => {
                      this.handleFetchExtensions()
                    }}
                    handleFetchNotificationLogs={() => {
                      this.handleFetchNotificationLogs()
                    }}
                    handleFetchInflightMessageModeration={() => {
                      this.handleFetchAppData('moderation')
                    }}
                    webhooksRoute={this.getWebhookRoutes()}
                    appExpired={appExpired}
                    activeTab={location.pathname}
                    plansAndBillingVisible={appDeleted !== 'inactive' && isAppOwner(activeApp)}
                  />
                  <AppNavMenuFooter appID={appID} activeApp={activeApp} appExpired={appExpired} />
                </div>
              </div>
            </MenuList>
          ) : (
            <div className={style.HeaderBrandingLogoWrapperMain}>
              <WelcomeHeader showProfile={false} />

              <AppNavMenu
                appID={appID}
                activeApp={activeApp}
                handleFetchAnalytics={() => this.handleFetchAnalytics()}
                handleFetchUsers={() => this.handleFetchUsers()}
                handleFetchGroups={() => this.handleFetchGroups()}
                handleFetchRoles={() => this.handleFetchRoles()}
                handleFetchChats={() => {
                  this.handleFetchAppData('moderation')
                  this.handleFetchAppData('messages')
                }}
                handleFetchCalls={() => this.handleFetchAppData('calls')}
                handleFetchWidgets={() => this.handleFetchAppData('widgets')}
                handleFetchModeration={() => {
                  this.handleFetchModerationComponents()
                }}
                handleFetchSettings={() => {
                  this.handleFetchAppData('settings')
                }}
                handleFetchCredentials={() => {
                  this.handleFetchApiKeys()
                }}
                handleFetchPlans={() => {
                  this.handleFetchAppData('billing')
                }}
                handleFetchMembers={() => {
                  this.handleFetchAppData('members')
                }}
                handleFetchBots={() => {
                  this.handleFetchBots()
                }}
                handleFetchWebhooks={() => {
                  this.handleFetchAllWebhooks()
                }}
                handleFetchExtensions={() => {
                  this.handleFetchExtensions()
                }}
                handleFetchNotificationLogs={() => {
                  this.handleFetchNotificationLogs()
                }}
                handleFetchInflightMessageModeration={() => {
                  this.handleFetchAppData('moderation')
                }}
                handleFetchAIAgentUserList={() => {
                  this.handleFetchAIAgentUserList()
                }}
                webhooksRoute={this.getWebhookRoutes()}
                appExpired={appExpired}
                activeTab={location.pathname}
                plansAndBillingVisible={appDeleted !== 'inactive' && isAppOwner(activeApp)}
                displayBanner={displayBanner}
              />
              <AppNavMenuFooter appID={appID} activeApp={activeApp} appExpired={appExpired} />
            </div>
          )}
        </div>
      </>
    )
  }
}

export default Menu
